module.exports = __webpack_public_path__ + "img/xmjkzxt3.358c07c1.jpg";